// Generated by https://quicktype.io

import { DealerBillingCount, DealerBillingDetail } from "./DTO/dealerBillingDetail.dto";
import { License } from "./license.model";
import { Store } from "./store";

export class Dealer {
	key: string;
	name: string;
	demo: boolean;
	contractFinanceEnabled: boolean;
	financeIntegration: number;
	adminEmail: string;

	supportEmail: string;

	adminPhone: string;

	supportPhone: string;
	venues: Store[];

	licenses: License[];

	billing: DealerBillingDetail;
	counts: DealerBillingCount;

	public constructor(init?: Partial<Dealer>) {
		Object.assign(this, init);
	}
}
